import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BoardMotif } from './BoardMotif';
import { ProductVisual } from './ProductVisual';
import { coaches, initials } from '../data/coaches';
const chips = ['6 Volumes', '5 Bonuses', '300 Pages', '71 Ready-to-Teach Sessions', 'A full season, planned'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it and teach from it'];
const avatarTones = ['bg-gold text-gold-ink', 'bg-green text-white', 'bg-ice text-ink', 'bg-crimson text-white', 'bg-gold-soft text-ink'];
export function Hero() {
  return <section className="board-ground relative w-full overflow-hidden border-b-4 border-gold" data-id="element-108" data-mp="s9ghk1uwwk98">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-109" data-mp="nbygsyr1tbcb">
        <BoardMotif className="absolute -right-16 -top-10 h-[260px] w-[260px] text-ice/[0.05] sm:h-[360px] sm:w-[360px]" data-id="element-110" data-mp="3d2bkbqsid1w2" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-5 pt-7 pb-14 sm:pt-10 sm:pb-20" data-id="element-111" data-mp="384jpop0hb1o6">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-112" data-mp="3j6fy7px5bddu">
          <div data-id="element-113" data-mp="3o6u87dib4xei">
            <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-114" data-mp="3o5j1p5xh9bjp">
              The no-prep system for chess club coaches
            </p>
            <h1 className="mt-3 font-display text-white text-[34px] leading-[1.08] sm:text-5xl md:text-6xl" data-id="element-115" data-mp="3e8ecsyc8z1z7">
              Your next chess club session is{' '}
              <span className="text-gold" data-id="element-116" data-mp="358hleoyh3p0g">already planned.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-white/75" data-id="element-117" data-mp="35akmc415z2jy">
              The No-Prep Chess Club Megapack is a six-volume coaching system: a
              full season of word-for-word session plans &mdash; lesson,
              puzzles, activity and printable worksheet for every meeting. Not a
              pile of lessons to sort through: the session itself, timed and
              sequenced, ready to teach.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-118" data-mp="s2bckbltt7bh">
              {chips.map(chip => <li key={chip} className="rounded-md border border-ice/25 bg-ice/[0.06] px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-cream" data-id="element-119" data-mp="nb1jf112jluu">
                  {chip}
                </li>)}
            </ul>
          </div>

          <ProductVisual eager data-id="element-120" data-mp="1azukfbwjsjwb" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-121" data-mp="1ayjhtfeu9i6s">
          <div className="w-full max-w-md" data-id="element-122" data-mp="16346au4azydj">
            <CtaButton data-id="element-123" data-mp="15zzwnh82kafh">Get the No-Prep Megapack</CtaButton>
          </div>
          <div className="mt-5 flex flex-col items-center gap-2.5 sm:flex-row sm:gap-4" data-id="element-124" data-mp="110wo3msvrm2r">
            <ul className="flex -space-x-2.5" data-id="element-125" data-mp="x0l48c8cdpsc">
              {coaches.map((coach, i) => <li key={coach.name} data-id="element-126" data-mp="3ltqclcptivti" data-mpi={i}>
                  {coach.avatar ? <img src={coach.avatar} alt={coach.name} width={40} height={40} loading="lazy" className="h-10 w-10 rounded-full border-2 border-navy-deep object-cover" data-id="element-127" data-mp="3hr3rrvrkeb5t" /> : <span aria-label={coach.name} className={`flex h-10 w-10 items-center justify-center rounded-full border-2 border-navy-deep font-display text-[12px] ${avatarTones[i % avatarTones.length]}`} data-id="element-128" data-mp="267wj4ir67s70">
                      {initials(coach.name)}
                    </span>}
                </li>)}
            </ul>
            <div className="text-center sm:text-left" data-id="element-129" data-mp="2tzle66vdmurn">
              <span className="flex justify-center gap-0.5 sm:justify-start" aria-label="Rated 4.9 out of 5" data-id="element-130" data-mp="2tz1xsuldkefq">
                {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-131" data-mp="zlswhq2zfz8k" />)}
              </span>
              <p className="mt-1 text-xs text-white/65" data-id="element-132" data-mp="3vjrvoi6lo7v8">
                <span className="font-bold text-white" data-id="element-133" data-mp="e8in9rv2qrb8">4.9/5</span> from 1,200+
                coaches running this system
              </p>
            </div>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-134" data-mp="3hpr202ui9b1q">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-135" data-mp="3csqvxrxno8am">
                <span className="h-1.5 w-1.5 rounded-[1px] bg-gold" data-id="element-136" data-mp="3rglmb1o6y0kj" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}